import { render } from "./fastNumPriceModel.vue?vue&type=template&id=11280068"
import script from "./fastNumPriceModel.vue?vue&type=script&lang=js"
export * from "./fastNumPriceModel.vue?vue&type=script&lang=js"

import "./fastNumPriceModel.vue?vue&type=style&index=0&id=11280068&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__